import styled from 'styled-components';
import CircleLoader from 'ggApp/shared/components/CircleLoader';

export const Root = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ContentWrapper = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Text = styled.div`
    margin-top: 40px;
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const Loader = styled(CircleLoader)`
    height: auto;
    flex-grow: 0;
`;
